import React from 'react'
import { useApiRegistrationState } from '../api/account/apiUsers'
import { LoadingSpinner } from '../genericComponents/LoadingSpinner'
import { PageWithCardContainer } from '../genericComponents/PageWithCardContainer'
import { FTUAccountDetailsCard } from './registrationSteps/FTUAccountDetailsCard'
import { FTUChangePasswordCard } from './registrationSteps/FTUChangePasswordCard'
import { TfaCard } from './registrationSteps/TfaCard'
import { FTURegistrationCompleteCard } from './registrationSteps/FTURegistrationCompleteCard'
import { TermAndConditionCard } from './registrationSteps/TermAndConditionCard'
import { useNavigate } from 'react-router'
/**
 * If backend enters through this page router go to url set in redirect without rendering
 * this page
 */
export const FTUPage: React.FC = () => {
  const { data } = useApiRegistrationState()
  const navigate = useNavigate()

  const state = data?._embedded?.registrationState
  if (state == 0) {
    void navigate('/login')
  }
  return (
    <PageWithCardContainer>
      {state ? (
        <RegistrationCardFromState registrationState={state} />
      ) : (
        <LoadingSpinner children={undefined} isLoading={false} />
      )}
    </PageWithCardContainer>
  )
}

const RegistrationCardFromState = (props: { registrationState: number }) => {
  const { registrationState } = props
  if (registrationState & registrationStates.TERMS_AND_CONDITIONS_NEED_TO_BE_APPROVED)
    return <TermAndConditionCard />
  else if (registrationState & registrationStates.ACCOUNT_DETAILS_NEEDED)
    return <FTUAccountDetailsCard />
  else if (registrationState & registrationStates.PASSWORD_CHANGE_NEEDED)
    return <FTUChangePasswordCard />
  else if (registrationState & registrationStates.TFA_REGISTRATION_NEEDED) return <TfaCard />
  else if (registrationState & registrationStates.FIRST_TIME_USER)
    return <FTURegistrationCompleteCard />
  else return <></>
}

const registrationStates = {
  DONE: 0,
  EMAIL_VERIFICATION_NEEDED: 1,
  PASSWORD_CHANGE_NEEDED: 2,
  TFA_REGISTRATION_NEEDED: 4,
  TERMS_AND_CONDITIONS_NEED_TO_BE_APPROVED: 8,
  FIRST_TIME_USER: 16,
  ACCOUNT_DETAILS_NEEDED: 32,
  ACCOUNT_SUSPENDED: 64,
  FIRST_WARNING_SENT: 128,
  SECOND_WARNING_SENT: 256,
}
